import Component from "../classes/Component";
import $ from 'jquery';

export default class AnchorLink extends Component {
  constructor() {
    super({});
    this.element = [
      $("[data-components-anchor-link]"),
    ];
    this.init();
  }
  init() {
    if (this.element) {
      this.linkToSection();
      this.stickyMenu();
      this.listenResize();
    }
  }
  linkToSection() {
    $('.second-menu__inside .link').click(function (e) {
      e.preventDefault();
      const target = $($(this).attr('href'));

      if(target.length){
        const scrollTo = target.offset().top - $('.second-menu').innerHeight() - $('.header').innerHeight() - 1.875+'rem';
        $('body, html').animate({scrollTop: scrollTo+'px'}, 300);
      }
    });
  }
  stickyMenu() {
    var sticky = $('.second-menu'),
      offetTop = sticky.offset().top;
    var heightHeader = $('.header').innerHeight(),
    heightSticky = sticky.innerHeight();

    if($(window).width() > 767) {
      sticky.css({'top': 8.3125+'rem' });
    } else {
      sticky.css({'top': heightHeader });
    }

    $(window).scroll(function(){
      var scroll = $(window).scrollTop();
      if (scroll > offetTop - heightSticky) {
        sticky.addClass('sticky');
      } else {
        sticky.removeClass('sticky');
      }
    });
  }
  listenResize() {
    window.addEventListener("resize", () => {
      this.stickyMenu();
    });
  }
}
